/**
 * Module-level navigation guard for Configure Project unsaved changes.
 *
 * Usage:
 * - ProjectDetail sets `onBlocked` when config modal is dirty.
 * - Header (or any navigator) calls `tryNavigate(path)`.
 *   If a guard is active, `onBlocked(path)` is called instead of navigating.
 */
const navigationGuard = {
  /** @type {((path: string) => void) | null} */
  onBlocked: null,
};

/**
 * Attempt navigation. If a guard is active, the navigation is blocked
 * and the pending path is forwarded to the guard owner.
 * @param {Function} navigate - react-router navigate function
 * @param {string} path - target path
 * @param {object} [options] - react-router navigate options
 * @returns {boolean} true if navigation proceeded, false if blocked
 */
export function safeNavigate(navigate, path, options) {
  if (navigationGuard.onBlocked) {
    navigationGuard.onBlocked(path);
    return false;
  }
  navigate(path, options);
  return true;
}

export default navigationGuard;
